module.exports = __webpack_public_path__ + "static/media/battle-net.29e4f7e1.svg";